(() => {
  const fold = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const matches = (note, query) => fold(query).trim().split(/\s+/).filter(Boolean).every(word => fold([note.title, note.caption, ...(note.topics || [])].join(' ')).includes(word.replace(/["']/g,'')));
  for (const root of document.querySelectorAll('[data-field-note-search]')) {
    if (root.dataset.ready) continue;
    root.dataset.ready = '1';
    const form=root.querySelector('form'), input=root.querySelector('input'), status=root.querySelector('[data-status]'), list=root.querySelector('[data-results]'), clear=root.querySelector('[data-clear]'), more=root.querySelector('[data-more-results]');
    let corpus, selected=[], shown=0, generation=0;
    async function load() {
      if (corpus) return corpus;
      corpus=(async()=> {
        let url=new URL(root.dataset.indexUrl, location.origin), result=[], seen=new Set(), pages=0;
        while(url) {
          if (url.origin !== location.origin || seen.has(url.href) || ++pages>100) throw Error('Invalid note pagination');
          seen.add(url.href);
          const response=await fetch(url,{credentials:'same-origin'});
          if(!response.ok) throw Error('Notes unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html'), node=doc.querySelector('[data-field-note-index]');
          if(!node) throw Error('Missing notes');
          const data=JSON.parse(node.textContent);
          if(!Array.isArray(data.items)) throw Error('Invalid notes');
          result.push(...data.items);
          url=data.next ? new URL(data.next,location.origin) : null;
          if(url)url.searchParams.set('section_id','osn-field-note-search-data');
        }
        const unique=new Map();
        for(const note of result) {
          const url=new URL(note.url || '',location.origin);
          if(url.origin===location.origin && /\/pages\/field-notes\//.test(url.pathname))unique.set(url.pathname,{...note,url:url.pathname,date:/^\d{4}-\d{2}-\d{2}$/.test(String(note.date || ''))?note.date:''});
        }
        return [...unique.values()].sort((a,b)=>String(b.date).localeCompare(String(a.date)));
      })().catch(error=>{corpus=null;throw error});
      return corpus;
    }
    function append() {
      for(const note of selected.slice(shown,shown+12)) {
        const li=document.createElement('li'), h=document.createElement('h3'), a=document.createElement('a'), p=document.createElement('p'), time=document.createElement('time');
        a.href=note.url;a.textContent=note.title;h.append(a);
        p.textContent=String(note.caption || '').slice(0,280)+(String(note.caption || '').length>280?'…':'');
        time.dateTime=note.date;time.textContent=note.date;li.append(h,p,time);list.append(li);
      }
      shown=Math.min(shown+12,selected.length);more.hidden=shown>=selected.length;
    }
    async function search(event) {
      if(event)event.preventDefault();
      const query=input.value.trim(), mine=++generation;list.replaceChildren();more.hidden=true;clear.hidden=!query;
      const url=new URL(location.href);query?url.searchParams.set('notes_q',query):url.searchParams.delete('notes_q');history.replaceState(null,'',url);
      if(!query){status.textContent='';return;}
      status.textContent=root.dataset.loading;
      try {
        const all=await load();if(mine!==generation)return;
        selected=all.filter(note=>matches(note,query));shown=0;
        status.textContent=selected.length?root.dataset.found.replace('[count]',selected.length):root.dataset.empty;
        append();
      } catch(error){if(mine===generation)status.textContent=root.dataset.failed;}
    }
    form.addEventListener('submit',search);more.addEventListener('click',append);
    clear.addEventListener('click',()=>{input.value='';search();input.focus();});
    input.addEventListener('input',()=>{if(!input.value)search();});
    const initial=new URL(location.href).searchParams.get('notes_q');if(initial){input.value=initial;search();}
  }
})();
